/** Long enough for any in-app deep link, short enough to refuse a payload smuggled in a query value. */
export const MAX_INTERNAL_RETURN_URL_LENGTH = 2048

/** C0 controls, DEL and C1 controls: browsers drop tab and newline from URLs, which can rebuild `//`. */
// eslint-disable-next-line no-control-regex -- matching control characters is the purpose
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f-\u009f]/

/**
 * The value of a `returnUrl` query parameter when it can only lead to a route of this app, else
 * `null`. `navigateByUrl` never leaves the origin, but a scheme-relative or backslash form would
 * still be an unvalidated deep link, and a sign-in page that echoes whatever it was given is how
 * an attacker's link gets the user to land somewhere unexpected after authenticating.
 */
export function parseInternalReturnUrl(value: unknown): string | null {
  if (typeof value !== 'string' || value.length > MAX_INTERNAL_RETURN_URL_LENGTH) {
    return null
  }
  if (!value.startsWith('/') || value.startsWith('//')) {
    return null
  }
  if (value.includes('\\') || CONTROL_CHARACTERS.test(value)) {
    return null
  }
  return value
}
